import * as service from "../service";

export interface SearchSociety {
  id: string;
  name: string;
  icon: string | null;
  university: string | null;
  /** Bare official handle; see `UserSociety.instagram_handle`. */
  instagram_handle: string | null;
  instagram_url: string | null;
  chop_image_url: string | null;
}

/**
 * Search societies / clubs by name.
 * Backend: GET /api/society/searchSocieties
 */
export const SearchSocietiesAPI = async (
  query?: string,
): Promise<SearchSociety[]> => {
  try {
    const resp = await service.call(
      "GET",
      "api/society/searchSocieties",
      query ? { q: query } : {},
    );
    if (resp?.status === 0 && resp?.resp) {
      return resp.resp as SearchSociety[];
    }
    return [];
  } catch (err) {
    console.error(`SearchSocietiesAPI ${err}`);
    return [];
  }
};
